module.exports = __webpack_public_path__ + "img/exam5.6d1b8e81.png";